import { render, staticRenderFns } from "./InformativeLabel.vue?vue&type=template&id=32d4f9e0&scoped=true&"
import script from "./InformativeLabel.vue?vue&type=script&lang=js&"
export * from "./InformativeLabel.vue?vue&type=script&lang=js&"
import style0 from "./InformativeLabel.vue?vue&type=style&index=0&id=32d4f9e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d4f9e0",
  null
  
)

export default component.exports